export type RoomKind = 'pantry' | 'cellar' | 'banquet' | 'brewery' | 'forge' | 'mine' | 'barracks' | 'vault';
export type RoomDefinition = { name:string; tint:string; light:string; floor:'stone'|'wood'|'moss'|'grate'|'rune' };
export const ROOMS:Record<RoomKind,RoomDefinition>={
  pantry:{name:'Le dispense',tint:'#242c1e',light:'#efc581',floor:'stone'},
  cellar:{name:'Le cantine allagate',tint:'#152c2d',light:'#a7d5b0',floor:'moss'},
  banquet:{name:'La sala del banchetto',tint:'#37221c',light:'#ffc87b',floor:'wood'},
  brewery:{name:'Il grande birrificio',tint:'#302817',light:'#ffb764',floor:'grate'},
  forge:{name:'Le forge incandescenti',tint:'#3c2019',light:'#ff9657',floor:'grate'},
  mine:{name:'Il pozzo delle talpe',tint:'#222331',light:'#c2c3f1',floor:'moss'},
  barracks:{name:'La caserma dei baffi',tint:'#222d37',light:'#bdcedc',floor:'wood'},
  vault:{name:'La riserva del capobirraio',tint:'#322b19',light:'#ffe7a6',floor:'rune'},
};
